import { Injectable } from '@angular/core';
import { Subject, Subscription, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import each from 'lodash/each';

@Injectable({
  providedIn: 'root',
})
export class WatcherService {
  private _eventBus: Subject<any>;

  private static _instance: WatcherService;

  constructor() {
    if (!WatcherService._instance) {
      WatcherService._instance = this;
    }

    this._eventBus = new Subject<any>();
  }

  /** @desc works as dispatchevent */
  broadcast(key: any, data?: any): void {
    this._eventBus.next({ key, data });
  }

  public static broadcastStatic(key: any, data?: any) {
    WatcherService._instance.broadcast(key, data);
  }

  /** @desc works as removeEventListener */
  suppress(subscription: Subscription): void {
    try {
      if (subscription) {
        subscription.unsubscribe();
      }
    } catch (e) {
      console.log('SUPRESS ERROR', e);
    }
  }

  /** @desc works as removeEventListener. Supresses all subscription. */
  suppressAll(subscription: Subscription[]): void {
    try {
      if (subscription && subscription instanceof Array) {
        each(subscription, (sub: Subscription) => {
          if (sub) {
            this.suppress(sub);
          }
        });
      }
    } catch (e) {}
  }

  /** @desc works as addEventListener */
  on<T>(key: string | string[]): Observable<T> {
    return this._eventBus.asObservable().pipe(
      filter(event => key === event.key),
      map(event => <T>event.data),
    );
  }
}
